<template>
	<b-container fluid class="d-flex flex-column h-100 overflow-hidden">
		<b-row ref="parentContainer" v-if="pins.length > 0" cols="4" no-gutters class="flex-grow-1 align-content-start overflow-hidden m-0">
			<b-col v-for="(pin, index) in paginatedPins" :key="index" 
				:ref="index === 0 ? 'sampleItem' : ''" class="p-2">
				<b-card no-body 
				:class="[`border h-100 w-100 pb-0 shadow-sm`, 
					{ [`border-${Variant}-dark bg-${Variant}-light`]: pin.Included },
					{ [`border-gray-dark bg-gray-light`]: !pin.Included }
					]"
					style="height: 4rem !important;"
					role="button"
					@click="$store.dispatch(FilterTreeStore + '/SetPropertiesFilterVisible', true); selectedPin = pin">
						<b-row align-v="start" no-gutters>
							<b-col cols="2">
								<!-- Bouton pour basculer entre Inclus (signe +) / Exclus (signe -) -->
								<b-icon @click.stop="toggleIncluded(pin);" 
									:icon="pin.Included ? 'plus' : 'dash'"  
									:class="'border-' + (pin.Included ? Variant : 'gray-dark')" 
									class="mx-1 border rounded-circle" />
							</b-col>
							<!-- Nom de la Pin -->
							<b-col cols="9">
								<!-- Mise en forme pour le type de tag par Propriété -->
								<template v-if="pin.Type===pinTypeEnum.None">
									<b-icon icon="tags" class="py-0" />
									<span class="d-inline-flex text-truncate" :style="{'max-width': '7rem'}" > {{ pin.Text }}</span>
								</template>

								<!-- Mise en forme pour le type de tag issu de l'Arborescence -->
								<template v-else-if="pin.Type===pinTypeEnum.Tree">
									<b-icon icon="ui-checks" class="py-0" />
									<span> {{ pin.Text }}</span>
								</template>

								<!-- Texte par défaut -->
								<span v-else> {{ pin.Text }}</span>
							</b-col>
							<!-- Case de suppression de la pin -->
							<b-col cols="1">
								<!-- Bouton pour supprimer le tag -->
								<b-icon @click.stop="removePin(pin);" icon="x" class="p-0 text-danger" role="button" />
							</b-col>
						</b-row>                                                                   
				</b-card>
			</b-col>
		</b-row>
		<b-row v-show="pins.length > perPage" align-h="between" class="w-100 py-1">
			<b-col>
				<b-pagination :ref="$id('pagination')" :total-rows="pins.length" v-model="currentPage" :per-page="perPage" class="p-0 m-0"  >
					<template #page="{ page, active }" >
							{{ page }}
					</template>
				</b-pagination>
			</b-col>
			<b-col class="px-0"></b-col>
			<b-col class="text-right px-0" >
				{{ (currentPage * perPage > pins.length ? pins.length : currentPage * perPage) + " " + $t('On') + " " + pins.length }}
			</b-col>
		</b-row>
		<!-- <b-row v-else class="p-5"> -->
			<!-- 'NoData.Line1' -> "Veuillez sélectionner sur l'arborescence les élements à regrouper et l'enregistrer" -->
			<!-- <div class="h6 text-center">{{ $t('NoData.Line1') }}<i class="bi bi-floppy" /> {{ $t('NoData.Line2') }} <b-icon icon="tags" /></div>
		</b-row> -->

		<!-- Filtre par propriétés -->
		<PropertiesFilter v-if="propertiesFilterVisible == true" v-model="propertiesFilterVisible" :FilterTreeStore="FilterTreeStore" :Pin.sync="selectedPin" :PropertiesFilterPinTypes="PropertiesFilterPinTypes" :PropertiesFilterObjectTypes="propertiesFilterObjectTypes" />
	</b-container>
</template>
<script lang="ts">
    import { Component, Ref, Watch } from 'vue-property-decorator';
    import locales from './locales/Pins.json'
    import BasePins from './Pins/BasePins';
	import Pin from '@/types/FilterTree/Pin';
	import PinTypeEnum from '@/enums/PinTypeEnum';
	import PropertiesFilter from './Pins/PropertiesFilter.vue';

    /** Composant d'affichage de Pins sous forme de carte */
    @Component({
		components: {
            PropertiesFilter
        },
        i18n: {messages: locales}
    })
    export default class PinsCards extends BasePins {
        /** Nécessaire pour pouvoir utiliser l'enum PinTypeEnum dans la section template */
        private pinTypeEnum = PinTypeEnum;

        /** Liste des pins locale pour pouvoir utiliser le b-form-tags */
        private pins: Pin[] = [] as Pin[];

		private currentPage: number = 1;
		private perPage: number = 8;

		get paginatedPins(): Pin[] {
			const start = (this.currentPage - 1) * this.perPage;
			return this.pins.slice(start, start + this.perPage);
		}

        /** 
         * Pointeur vers fonction pour désactiver watchers
         * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
         **/
        private unwatchGetPins = undefined;

		@Watch('pins', { deep: true })
		private onPinsChange() {
			this.calculateCapacity();
		}

		// @Ref('parentContainer') readonly parentContainer!: any;
  		// @Ref('sampleItem') readonly sampleItem!: any[];

		async calculateCapacity() {
			console.debug("PinsCards - calculateCapacity()");
			// On attend que le navigateur ait fini de dessiner
			window.requestAnimationFrame(() => {
				// let parentContainer = this.$refs['parentContainer'] as HTMLElement;
				let rowEl = this.$refs['parentContainer'] as HTMLElement; //(parentContainer?.$el || parentContainer) as HTMLElement;

				let firstCol;

				let sampleItem = this.$refs['sampleItem'] as HTMLElement;
				if (sampleItem)
					firstCol = sampleItem[0] as HTMLElement;

				console.debug("PinsCards - calculateCapacity() - rowEl : %O - sampleItem : %O", rowEl, sampleItem);

				if (!rowEl || !firstCol) return;

				// 1. On récupère les styles calculés pour inclure les marges
				const style = window.getComputedStyle(firstCol);
				const marginTop = parseFloat(style.marginTop);
				const marginBottom = parseFloat(style.marginBottom);
				const marginLeft = parseFloat(style.marginLeft);
				const marginRight = parseFloat(style.marginRight);

				// 2. Taille réelle d'une carte (Dimensions + Marges)
				const itemWidth = firstCol.offsetWidth + marginLeft + marginRight;
				const itemHeight = firstCol.offsetHeight + marginTop + marginBottom;

				// 3. Espace disponible
				// On ajoute une petite tolérance de 1 ou 2 pixels pour les arrondis des navigateurs
				const tolerance = 2;
				const availableWidth = rowEl.clientWidth + tolerance;
				const availableHeight = rowEl.clientHeight + tolerance;
				console.debug("PinsCards - calculateCapacity() - availableWidth : %O - availableHeight : %O", availableWidth, availableHeight);

				// 4. Calcul du nombre de colonnes et lignes
				const cols = Math.floor(availableWidth / itemWidth);
				const rows = Math.floor(availableHeight / itemHeight);
				
				console.debug("PinsCards - calculateCapacity() - cols : %O - rows : %O", cols, rows);
				
				const newPerPage = Math.max(1, cols * rows);

				if (this.perPage !== newPerPage)
					this.perPage = newPerPage;
			});
		}

        /** La hauteur de la barre de filtres est redimenssionnée à chaque mise à jour de liste de Pins ou bien sur redimenssionement de la fenêtre */
        async created() {
			console.debug("PinsCards - created()");

            this.propertiesFilterObjectTypes = this.$store.getters[this.FilterTreeStore + '/PropertiesFilterObjectTypes'];

            this.unwatchGetPins = this.$store.watch((state, getters) => getters[this.FilterTreeStore + '/GetPins'], val => {
                console.debug('Pins -> val [%O] filterPin %O', val, this.FilterPins)
                if(this.FilterPins)
                    this.pins = val.filter(this.FilterPins);
                else
                    this.pins = val;
            }, { deep: true, immediate: true })


            /** Chargement de la liste des filtres existants sur le server */
            await this.$store.dispatch(this.FilterTreeStore + "/LoadFilters");
        }

		mounted() {
			this.$nextTick(() => {
                // Permet le check si la hauteur de la b-form-tags dépasse la hauteur des pins empilés ou non lorsque la fenêtre du navigateur est redimensionnée
                window.addEventListener('resize', this.calculateCapacity);
            });

			// Premier calcul immédiat
			this.calculateCapacity();
		}

        beforeDestroy() {
            console.debug("Pins - beforeDestroy()");
            window.removeEventListener('resize', this.calculateCapacity);

            // Libération du watcher
            if (this.unwatchGetPins)
                this.unwatchGetPins();
        }
    }
</script>
<style scoped>
    /** Pour élargir la dropdown contenant la liste des filtres chargeables */
    :deep(.dropdown-menu.show.enlarge) {
        min-width: 20rem !important;
        max-width: 20rem !important;
    }   

    /** Pour afficher une couleur de fond sur les items de la dropdown
        @todo Faire en sorte que le secondary soit utilise plutôt le Variant dynamiquement
    */
    :deep(.dropdown-item:hover) {
        background-color: var(--secondary-bg-subtle) !important;
    }
</style>
